import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../shared/providers/validation.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoaderService } from '../shared/providers/loader.service';
import { UserOffersModel } from '../shared/models/UserOffersModel';
import { IUser } from '../shared/models/user';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { BrokerSelecttionModel } from '../shared/models/SavePropertyInputModel';
import { SelectedIdInputmodel } from '../shared/models/SelectedIdInputmodel';
import { SavePropertyContactUserInput } from '../shared/models/SavePropertyContactUserInput';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { UserRole } from '../shared/enum/enum';
import { ToastService } from '../shared/providers/toast.service';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

@Component({
  selector: 'user-offers',
  templateUrl: './user-offers.component.html',

})

export class UserOffersComponent {
  constructor(private _userManagerService: UserManagerService, public permissionService: PermissionService, private _toastService: ToastService, private _propertyManagementService: PropertyManagementService, public Validation: ValidationService, private activatedRoute: ActivatedRoute, private Loader: LoaderService, private http: HttpClient, public authService: AuthenticationService, private router: Router, public _validationService: ValidationService) {

  }
  @Input() CurrentUser = {} as IUser;
  @Input() principalDetails = {} as IUserDetails;
  IsDataProcessing = false;
  user: any;
  protected readonly BASE_URL: string = environment.base_url;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtoptions = {};
  DDColumns = [];
  Modules = Modules;
  Actions = Actions;
  propertyList: UserOffersModel[] = [];
  selectAll = false;
  isBroker = false;
  IsEditClicked = false;
  brokers: BrokerSelecttionModel[] = [];
  selectedInputModel: SelectedIdInputmodel[] = [];
  propertyContactInput = {} as SavePropertyContactUserInput;
  selectedLiveListings: UserOffersModel[] = [];
  IsEmployee = true;
  bulkBrokerId: number = 0;
  IsPrincipal = false;
  userRole = UserRole;

  ngOnInit() {
    this.user = this.authService.user;
    if (this.principalDetails.UserRoleId == this.userRole.Admin || this.principalDetails.UserRoleId == this.userRole.SuperAdmin || this.principalDetails.UserRoleId == this.userRole.Broker || this.principalDetails.UserRoleId == this.userRole.ExternalBroker) {
      this.IsEmployee = true;
      let currentTypeId = (this.principalDetails.UserRoleId == this.userRole.Admin || this.principalDetails.UserRoleId == this.userRole.SuperAdmin || this.principalDetails.UserRoleId == this.userRole.Broker) ? 0 : 1;
      this.bindBrokers(currentTypeId);
    }
    else {
      this.IsEmployee = false;
      this.IsEditClicked = false;
    }

    if (this.principalDetails.UserRoleId == this.userRole.Principal || this.principalDetails.UserRoleId == this.userRole.Principal1031 || this.principalDetails.UserRoleId == this.userRole.Seller) {
      this.IsPrincipal = true;
    }

    this.isBroker = this.authService.Broker();
    this.DDColumns = [
      { data: 'IsSelected' },
      { data: 'IsSelected' },
      { data: 'LeadName' },
      { data: 'PropertyName' },
      { data: 'Status' },
      { data: 'OfferDate' },
      { data: 'OfferPrice' },
      { data: 'Price' },
      { data: 'Id' }
    ];

    this.getProperties();
    this.bindBrokers();
  }
  onBrokerClick() {
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      this.bulkBrokerId = 0;
    }
  }

  bindBrokers(typeId:number=0) {
    this._propertyManagementService.getBrokersForOffers(typeId).subscribe(response => {
      if (response != null && response.length > 0) {
        response = response.filter(f => f.Id != this.CurrentUser.Id);
      }
      this.brokers = response;
    });
  }
  getProperties() {
    let orderid = this.IsPrincipal ? 3 : 2;
    this.dtoptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[orderid, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsDataProcessing = true;
        let currentPropertyList = this.selectedLiveListings.length > 0 ? this.selectedLiveListings.map(i => i.Id) : [];
        const filter =
        {
          IsBuy: true,
          PropertyLst: currentPropertyList,
          //  IsArchive: this.isArchive
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.Validation.GetAuthHeader();
        this.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/userAssociatedOffers/' + this.CurrentUser.Id + '/' + this.user.Id,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            this.propertyList = resp.data ? resp.data : [];

            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            this.IsDataProcessing = false;
            $(".paginate_button.first,.paginate_button.last").hide();
          });
      },
      columnDefs: [
        { orderable: false, targets: 0 }
      ],
      columns: this.DDColumns
    };
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.UnSelectAll(false);
    }
  }

  UnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      item.BrokerId = 0;
    });
    this.selectedLiveListings = [];
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      this.bulkBrokerId = 0;
    }
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }
  selectOrUnSelectAll(trueOrfalse) {
    this.propertyList.filter(f => f.IsCoBroker).forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        if (this.selectedLiveListings.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedLiveListings.push(item);
        }
      }
      else {
        this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == item.Id), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  editUserOffers() {
    this.IsEditClicked = true;
  }

  clearSelectedContact() {
    this.IsEditClicked = false;
  }

  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertyList.find(x => x.Id == Id);
      if (prop = null) {
        prop.IsSelected = true;
        this.selectedLiveListings.push(prop);
      }

    }
    else {
      let prop = this.propertyList.find(x => x.Id == Id);
      if (prop != null) {
        prop.IsSelected = false;
        prop.BrokerId = 0;
      }
      if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
        this.bulkBrokerId = 0;
      }
      this.selectedLiveListings = this.selectedLiveListings.filter(x => x.Id !== Id);
    }
    this.autoSelectAll();
  }
  autoSelectAll() {
    if (this.propertyList.filter(x => x.IsSelected == true).length == this.propertyList.length && this.propertyList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  autoSelectProperties() {
    if (this.propertyList != null && this.propertyList.length > 0) {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.propertyList.forEach(item => {
          if (this.selectedLiveListings.findIndex(f => f.Id == item.Id) > -1) {
            let currentBroker = this.selectedLiveListings.find(f => f.Id == item.Id);
            if (currentBroker != null && currentBroker != undefined && currentBroker.BrokerId != null) {
              item.BrokerId = currentBroker.BrokerId;
            }
            item.IsSelected = true;
          }
        });
      }

      if (this.propertyList.findIndex(f => !f.IsSelected) > -1) {
        this.selectAll = false;
      }
      else {
        this.selectAll = true;
      }
    }
  }

  onBrokerChange(event: any, property: any) {
    if (event != null && event.target.value != null) {
      property.BrokerId = event.target.value;
      this.selectedLiveListings.push(property);
    }
    else {
      property.BrokerId = 0;
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.selectedLiveListings = this.selectedLiveListings.filter(x => x.Id !== property.Id);
      }

    }
  }

  saveUserOffers() {
    if (this.propertyList != null) {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.selectedInputModel = this.selectedLiveListings.map(o => { return { Id: o.Id, BrokerId: o.BrokerId }; });
        if (this.selectedInputModel != null && this.selectedInputModel.length > 0) {
          this.user = this.authService.user;
          this.propertyContactInput = {} as SavePropertyContactUserInput;;
          this.propertyContactInput.UserId = this.CurrentUser.Id;
          this.propertyContactInput.Type = 3;
          this.propertyContactInput.SelectedValues = this.selectedInputModel;
          this._propertyManagementService.savePropertyContactForDeleteUser(this.propertyContactInput).subscribe(response => {
            if (response) {
              this.Loader.display(false);
              this.dtElement.dtInstance.then(x => x.draw());
              this.selectedLiveListings = [];
              this.IsEditClicked = false;
              this.propertyContactInput = null;
              this.bulkBrokerId = 0;
              this.propertyList = [];
              this.selectAll = false;
              this._toastService.addToast({ title: 'Success', msg: "New Broker Added Successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

            }
            else {
              this.Loader.display(false);
              this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            }
          });
        }
        else {
          this.Loader.display(false);
          this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });

        }
      }
    }
  }

  onBulkBrokerChange(event: any) {
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      // this.bulkBrokerId = 0;
      this._toastService.addToast({ title: 'Error', msg: "Please select the Offers.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.selectedLiveListings = [];
      this.propertyList.filter(f => f.IsSelected).forEach(item => {
        item.BrokerId = this.bulkBrokerId;
      });
      this.selectedLiveListings = this.propertyList.filter(f => f.IsSelected);
    }

  }

}
